<div class="user-wrapper">
  <div class="hero card-glass mb-3">
    <div class="crumb">
      <a routerLink="/utilisateur/statistiques" class="crumb-link"><i class="bi bi-arrow-left"></i> Retour aux statistiques</a>
      <span class="crumb-current">Rapport mensuel</span>
    </div>
    <div class="hero-flex">
      <div>
        <p class="eyebrow">Spay · Synthèse</p>
        <h1>Vue mensuelle</h1>
        <p class="lead">Totals des dépôts, retraits, transferts et achats par mois.</p>
      </div>
    </div>
  </div>

  <div class="card-glass p-3 mb-3">
    <div class="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-2">
      <h4 class="mb-0">Rapport</h4>
      <div class="d-flex align-items-center gap-2 w-100 w-sm-auto">
        <label class="mb-0" for="monthSelectMensuPerso">Mois</label>
        <select id="monthSelectMensuPerso"
          class="form-select form-select-sm bg-dark text-light border-secondary w-100 w-sm-auto"
          [(ngModel)]="selectedMonth" (change)="applyMonthFilter(selectedMonth)">
          <option *ngFor="let m of monthOptions" [value]="m.value">{{ m.label | titlecase }}</option>
        </select>
      </div>
    </div>
    <!--<p class="text-muted small mb-0">Par défaut, le mois courant est affiché. Sélectionnez un mois précédent pour revoir un rapport déjà chargé.</p>-->
  </div>

  <div class="row g-3">
    <div class="col-sm-6 col-lg-4" *ngFor="let m of mensuelist">
      <div class="card card-glass h-100">
        <div class="card-header border-0 text-white font-weight-bolder text-center">
          {{m.month}}/{{m.annee}}
        </div>
        <div class="card-body">
          <div class="metric-row"><span>Total dépôt</span><strong>{{m.depot | currency:m.sigleMonnaie}}</strong></div>
          <div class="metric-row"><span>Total retrait</span><strong>{{m.retrait | currency:m.sigleMonnaie}}</strong>
          </div>
          <div class="metric-row"><span>Total transferts</span><strong>{{m.transfert |
              currency:m.sigleMonnaie}}</strong></div>
          <div class="metric-row"><span>Total achats</span><strong>{{m.achat | currency:sigle}}</strong></div>
          <div class="metric-row"><span>Achats en ligne</span><strong>{{m.achatEnLigne |
              currency:m.sigleMonnaie}}</strong></div>
        </div>
      </div>
    </div>
    <div class="col-12" *ngIf="!mensuelist || mensuelist.length === 0">
      <div class="card card-glass p-3 text-center text-muted">Aucun rapport mensuel disponible.</div>
    </div>
  </div>
</div>
